import Vue from 'vue'
import store from '@/store'

let _baixar = (parcela, analise, analisesPedido) => {

    let data = {
        "pessoa_id": analise.pessoa_id,
        "tipoJuros": "ncap",
        "demonstrativo": store.state.Empresa.configuracao.demonstrativoContaBancaria,
        "model": {
            "total": parcela[0].valor,
            "acrescimo": "0,00",
            "desconto": "0,00",
            "dataBaixa": new Date().toLocaleDateString()
        },
        "parcelas_selecionadas": parcela,
        "tipo_conta": "R"
    }

    Vue.httpNumerama.post('/api/contas/parcelas/baixar', data).then(async (res) => {
        if (res.data.erro === 1) {
            window.swal("Atenção", "Houve um problema ao baixar parcela. <br><br>" + res.data.stack, "warning")
            throw new Error("Houve um problema ao baixar parcela. \r\n" + res.data.stack)
        }

        Vue.http.post('/api/analises/vincula-informacao-pedido', {analises: analisesPedido, pedido: null});
        return res
    })
};

let baixar = async (parcela, analise, analisesPedido) => {
    return await _baixar(parcela, analise, analisesPedido)
};

export default {
    baixar
}
